// ChatResponsiveDesignLayout.js
'use client';
import { connect } from 'react-redux';

import ChatResponsiveDesignLayout from '../page/ChatResponsiveDesignLayout.jsx';
import getOperationData from '../selector/getOperationData.js';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = state => {
  const deviceWidth = getOperationData(state, ['device'], 'width');

  return {
    isOnDesktop: deviceWidth > breakpoint.mobile,
    deviceHeight: getOperationData(state, ['device'], 'height'),
  };
};

export default connect(mapStateToProps, null)(ChatResponsiveDesignLayout);
